module.exports = "/assets/data/a9a496b2451b3a0113ecb4ec02d93293-SM2.data.json";